var GEO_DATA, Geocoder, KeywordBar, Location, LocationBar, LocationError, SearchBarView, Typeahead, breakDownAddress, getGeoSearchOverrideUrl, getLocationForSearch, getLocationOverrideUrl, getSearchOverrideUrl, getSearchUrl, placeholderState, ref, saveRecentSearch, setSiteCookies, storeGeolocationData, whichKeyAlias,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  slice = [].slice;

require('../../../../../../core/frontend/groupon_modules/groupon');

Geocoder = require('../../../../../../src/frontend/helper/search/common/m_geocoder');

Location = require('../../../../../../src/frontend/helper/search/helper/m_location_helper');

setSiteCookies = require('../../../../../../core/frontend/groupon_modules/setSiteCookies');

Groupon.setWindowLocation = require('../../../../../../core/frontend/groupon_modules/setWindowLocation');

KeywordBar = require('../../../../../../src/frontend/helper/search/view/m_keyword_bar');

LocationBar = require('../../../../../../src/frontend/helper/search/view/m_location_bar');

LocationError = require('../../../../../../src/frontend/helper/search/view/m_error');

Typeahead = require('../../../../../../src/frontend/helper/search/view/m_typeahead');

saveRecentSearch = require('../../../../../../src/frontend/helper/search/helper/m_typeahead_helper.coffee').saveRecentSearch;

whichKeyAlias = require('../../../../../../src/frontend/helper/search/common/m_keypress').whichKeyAlias;

placeholderState = require('../../../../../../src/frontend/helper/search/helper/m_common').placeholderState;

ref = require('../../../../../../src/frontend/helper/search/helper/m_searchbar_helper'), breakDownAddress = ref.breakDownAddress, getGeoSearchOverrideUrl = ref.getGeoSearchOverrideUrl, getLocationForSearch = ref.getLocationForSearch, getLocationOverrideUrl = ref.getLocationOverrideUrl, getSearchOverrideUrl = ref.getSearchOverrideUrl, getSearchUrl = ref.getSearchUrl, GEO_DATA = ref.GEO_DATA, storeGeolocationData = ref.storeGeolocationData;

module.exports = SearchBarView = (function() {
  var head, keyword, translations;

  head = document.head || document.getElementsByTagName('head')[0];

  keyword = translations = void 0;

  function SearchBarView(arg) {
    var $el;
    $el = arg.$el;
    this.redirectTo = bind(this.redirectTo, this);
    this.geocoderError = bind(this.geocoderError, this);
    this.geocoderSuccess = bind(this.geocoderSuccess, this);
    this.searchWithAutocomplete = bind(this.searchWithAutocomplete, this);
    this.searchWithGmaps = bind(this.searchWithGmaps, this);
    this.searchWithGeolocation = bind(this.searchWithGeolocation, this);
    this._cleanGeolocationTraces = bind(this._cleanGeolocationTraces, this);
    this.unfreezeElements = bind(this.unfreezeElements, this);
    this.setSearchbarFocusTracking = bind(this.setSearchbarFocusTracking, this);
    this.onFormSubmit = bind(this.onFormSubmit, this);
    this.gatherData = bind(this.gatherData, this);
    this.getQuery = bind(this.getQuery, this);
    this.$form = $el;
    this.env = 'desktop';
    this.$body = $(document.body);
    this.$inputs = $el.find('#location, #search');
    this.$location = $el.find('#location');
    this.$search = $el.find('#search');
    this.$searchResultList = $('#ls-search-results');
    this.$mobileSubnav = $('.ls-mobile-subnav');
    this.$locationMobileSubnav = $('.ls-mobile-subnav-location');
    this.$primaryNavTabs = $('.primary-nav-tab');
    this.$overlay = $('#ls-resp-overlay');
    this.$submitButton = $('#ls-header-search-button');
    this.render();
    this.bind();
    this.country = document.head.getAttribute('data-country') || 'US';
    translations = Groupon.LS.translations;
    this.geolocationData = Location.getGeolocationData();
  }

  SearchBarView.prototype.bind = function() {
    this.$form.on('submit', (function(_this) {
      return function(e, state) {
        e.state = state;
        return _this.onFormSubmit(e);
      };
    })(this));

    /*
     * Input events
     */
    this.$inputs.on({
      'input focusin': (function(_this) {
        return function(e) {
          var el;
          el = e.currentTarget;
          placeholderState.toggle($(el));
          return _this.typeahead.buildAutocompleteList(e, el.name);
        };
      })(this),
      keydown: (function(_this) {
        return function(e) {
          var $match;
          switch (whichKeyAlias(e)) {
            case 'Enter':
              if (e.currentTarget.name === 'location') {
                e.preventDefault();
                if (($match = _this.typeahead.$container.find('.typeahead-match-highlight')).length) {
                  $match.trigger('click');
                } else {
                  _this.typeahead.hide();
                  _this.$form.trigger('submit', 'manual');
                }
              }
              break;
            case 'Tab':
              _this.typeahead.hide();
              break;
            case 'ArrowDown':
              _this.$searchResultList.find('a').eq(0).focus();
              _this.$searchResultList.find('.typeahead-match').removeClass('typeahead-match-highlight');
              e.preventDefault();
          }
        };
      })(this),
      focusin: (function(_this) {
        return function(e) {
          var $parent;
          _this.$body.eventPause('pause');
          if (!($parent = $(e.currentTarget).parent()).hasClass('active-search')) {
            _this.$form.find('label, div').removeClass('active-search');
            return $parent.addClass('active-search');
          }
        };
      })(this),
      focusout: (function(_this) {
        return function(e) {
          var $locLabel, $searchLabel, $this;
          _this.$body.eventPause('active');
          $this = $(e.currentTarget);
          $this.parent().removeClass('active-search');
          placeholderState.toggle($this);
          if (!$('html.ui-v3').length) {
            $searchLabel = _this.$search.parent('label');
            $locLabel = _this.$location.parent('label');
            if (!$searchLabel.is('.active-search') && !$locLabel.is('.active-search')) {
              return $searchLabel.addClass('active-search');
            }
          }
        };
      })(this)
    });

    /*
     * Global events
     */
    this.$body.on('click', (function(_this) {
      return function() {
        return _this.typeahead.hide();
      };
    })(this));
    $(window).one('load', (function(_this) {
      return function() {
        return _this.$form.find('input').each(function() {
          return placeholderState.toggle($(this));
        });
      };
    })(this));

    /*
     * Typeahead events
     */
    this.$searchResultList.on('click', 'a', (function(_this) {
      return function(e) {
        if ($(e.currentTarget).hasClass('current-location')) {
          e.preventDefault();
          _this.$form.trigger('submit', 'geolocate');
        } else {
          _this.selectAndFill(e);
        }
      };
    })(this));
    return this.$searchResultList.on('keydown', 'a', (function(_this) {
      return function(e) {
        var $el, $results, $widget;
        e.preventDefault();
        $widget = _this.$searchResultList;
        $results = $widget.find('a');
        switch (whichKeyAlias(e)) {
          case 'Enter':
            $el = $(e.currentTarget);
            if ($el.hasClass('current-location')) {
              return $el.trigger('click');
            } else {
              return _this.selectAndFill(e);
            }
            break;
          case 'ArrowUp':
            return $results.eq($results.index(e.currentTarget) - 1).focus();
          case 'ArrowDown':
            return $results.eq($results.index(e.currentTarget) + 1).focus();
          default:
            if (whichKeyAlias(e) === 'Tab' && $widget.is('typeahead-search')) {
              return _this.selectAndTab(e);
            } else {
              return _this.$searchResultList.prev('input').focus();
            }
        }
      };
    })(this));
  };


  /*
   * Write deal data to deal input from autocomplete item
   *
   * @param {Object} $trigger - jQuery object of autocomplete item
   */

  SearchBarView.prototype.updateValue = function($trigger) {
    placeholderState.set(this.$search, 'hide');
    this.$search.val($trigger.data('value'));
  };


  /*
   * Set location data to location input from autocomplete item
   *
   * @param {Object} $trigger - jQuery object of autocomplete item
   */

  SearchBarView.prototype.updateValueAndLatLng = function($trigger) {
    var data, division, lat, lng, value;
    data = $trigger.data();
    value = data.value, lat = data.lat, lng = data.lng, division = data.division;
    data = {
      lat: lat.toString(),
      lng: lng.toString(),
      division: division,
      'manual': false
    };
    this.$location.val(value).data(data);
  };


  /*
   * Autocomplete link handler
   * Updates deal or location input
   *
   * @param {Object} e - jQuery event
   */

  SearchBarView.prototype.selectAndFill = function(e) {
    var $trigger, $widget, matchClass, state;
    $trigger = $(e.currentTarget);
    $widget = this.$searchResultList;
    if (!$trigger.hasClass(matchClass = 'typeahead-match')) {
      $widget.find('.typeahead-match').removeClass(matchClass);
    }
    if ($widget.hasClass('typeahead-location')) {
      state = 'autocomplete';
      this.updateValueAndLatLng($trigger);
    } else {
      state = void 0;
      this.updateValue($trigger);
    }
    this.$form.trigger('submit', state);
  };

  SearchBarView.prototype.selectAndTab = function(e) {
    this.updateValueAndLatLng($(e.currentTarget));
    this.$searchResultList.hide();
    this.$location.focus();
  };

  SearchBarView.prototype.render = function() {
    var enableBetterUx, enableGeolocation, enableRecentSearches, experiments, options, ref1, ref2, ref3;
    ref1 = Groupon.LS, options = ref1.options, experiments = ref1.experiments;
    if (options == null) {
      options = {};
    }
    options = _.assign({}, options, experiments);
    if (options != null) {
      enableGeolocation = options['enableGeolocation'] || options['LS-2613-current-location'];
      enableBetterUx = options['LS-2685-location-field-ux'];
      enableRecentSearches = true;
    }
    this.typeahead = new Typeahead({
      env: this.env,
      resultList: this.$searchResultList,
      endpoints: {
        search: (ref2 = Groupon.endpoints) != null ? ref2.deals : void 0,
        location: (ref3 = Groupon.endpoints) != null ? ref3.locations : void 0
      },
      enableGeolocation: enableGeolocation,
      enableRecentSearches: enableRecentSearches,
      enableBetterUx: enableBetterUx
    });
    this.locationError = new LocationError({
      $el: this.$form,
      $resultList: this.$searchResultList,
      env: this.env,
      enableBetterUx: enableBetterUx
    });
    this.keywordBar = new KeywordBar({
      el: this.$form,
      env: this.env
    });
    this.locationBar = new LocationBar({
      el: this.$form,
      env: this.env
    });
    return this.setSearchbarFocusTracking();
  };

  SearchBarView.prototype.getQuery = function() {
    var maxChars, ref1, ref2;
    maxChars = this.$search.attr('maxlength') || 50;
    keyword = (ref1 = this.keywordBar) != null ? (ref2 = ref1.val()) != null ? ref2.trim().slice(0, maxChars) : void 0 : void 0;
    if (!_.isBlank(keyword)) {
      return keyword;
    }
  };

  SearchBarView.prototype.gatherData = function(state) {
    var data, dealSearch, geoMaximumAge, geolocationData, locData, locSearch, locationMatch, ref1, ref2, ref3;
    geolocationData = (ref1 = this.geolocationData) != null ? ref1.current_location : void 0;
    dealSearch = this.getQuery();
    locSearch = this.locationBar.val();
    if (!((dealSearch != null) || (locSearch != null))) {
      return;
    }
    if (dealSearch != null) {
      saveRecentSearch(dealSearch, 'deal');
    }
    if (Groupon.LS.experiments['enableRecentLocations']) {
      saveRecentSearch(locSearch, 'location');
    }
    if ((locationMatch = $('.typeahead-location .typeahead-match')).length) {
      data = _.pick(locationMatch.data(), 'lat', 'lng');
    } else {
      locData = this.$location.data();
      if (locData.manual && state === void 0) {
        state = 'manual';
      }
      switch (state) {
        case 'autocomplete':
        case 'manual':
          data = _.pick(locData, 'lat', 'lng', 'closestDivision');
          break;
        default:
          data = _.pick.apply(_, [locData, 'lat', 'lng', 'closestDivision'].concat(slice.call(GEO_DATA)));
          geoMaximumAge = (ref2 = Groupon.Modules.SearchBar.geolocationOptions) != null ? ref2.maximumAge : void 0;
          if (geoMaximumAge && Date.now() - (geolocationData != null ? geolocationData.timeStamp : void 0) > geoMaximumAge) {
            state = 'geolocate';
          }
      }
    }
    if (!geolocationData || !data.closestDivision) {
      data.closestDivision = (ref3 = Groupon.division) != null ? ref3.id : void 0;
    }
    return {
      data: _.extend(data, {
        address: locSearch,
        query: keyword
      }),
      state: state
    };
  };

  SearchBarView.prototype.lockSubmit = function(lock) {
    if (lock == null) {
      lock = false;
    }
    if (lock) {
      this.$submitButton.attr('disabled', true).removeClass('icon-magnifying-glass').addClass('ls-loading-white');
    } else {
      this.$submitButton.attr('disabled', false).removeClass('ls-loading-white').addClass('icon-magnifying-glass');
    }
  };

  SearchBarView.prototype.onFormSubmit = function(e) {
    var data, fn, overrideUrl, ref1, state;
    e.preventDefault();
    state = e.state;
    ref1 = this.gatherData(state), data = ref1.data, state = ref1.state;
    if (data == null) {
      return;
    }
    this.lockSubmit(true);
    this.$location.eventPause('pause').addClass('search-hide-selection');
    this.$primaryNavTabs.eventPause('pause');
    overrideUrl = getGeoSearchOverrideUrl(data.query, data.address);
    if (overrideUrl != null) {
      return Groupon.setWindowLocation(overrideUrl);
    }
    switch (state) {
      case 'geolocate':
        data.currentLocation = true;
        fn = this.searchWithGeolocation;
        break;
      case 'autocomplete':
        fn = this.searchWithAutocomplete;
        Location.removeGeolocationData('current_location');
        break;
      case 'manual':
        fn = this.searchWithGmaps;
        Location.removeGeolocationData('current_location');
        break;
      default:
        fn = this.redirectTo;
    }
    return fn(data);
  };

  SearchBarView.prototype.setSearchbarFocusTracking = function() {
    return this.$form.on('focusin.searchbar', (function(_this) {
      return function(e) {
        if (e.target && $(e.currentTarget).find(e.target).length) {
          Groupon.Utils.trackEvent('searchbar-focusin');
          _this.$form.off('focusin.searchbar');
          return _this.$form.on('focusout.searchbar', function(e) {
            if (!$(e.currentTarget).find(e.relatedTarget).length) {
              Groupon.Utils.trackEvent('searchbar-focusout');
              _this.$form.off('focusout.searchbar');
              return _this.setSearchbarFocusTracking();
            }
          });
        }
      };
    })(this));
  };

  SearchBarView.prototype.unfreezeElements = function() {
    this.$location.eventPause('active');
    return this.$primaryNavTabs.eventPause('active');
  };

  SearchBarView.prototype._cleanGeolocationTraces = function() {
    var data, lat, lng, name, options;
    Location.removeGeolocationData('current_location');
    Location.setGeolocationData('geoLocationGranted', false);
    if (translations.search.currentlocation === this.$location.val() && ((data = Groupon.division) != null)) {
      lat = data.lat, lng = data.lng, name = data.name;
      options = {
        address: name,
        lat: lat,
        lng: lng,
        geocoderSuccess: (function(_this) {
          return function(arg) {
            var locationData;
            locationData = arg.locationData;
            _this.$location.data(locationData).val(locationData.friendlyName);
            return Location.setSearchLocCookie(locationData);
          };
        })(this),
        geocoderError: function() {}
      };
      return this.searchWithGmaps(options);
    }
  };

  SearchBarView.prototype.searchWithGeolocation = function(data) {
    var geoLocationError, geolocationSuccess, query;
    if (data == null) {
      query = this.getQuery();
      data = {
        address: translations.search.nearme,
        query: query
      };
    }
    $('.typeahead-response.location').hide();
    geolocationSuccess = (function(_this) {
      return function(arg) {
        var lat, lng;
        lat = arg.lat, lng = arg.lng;
        _this.$location.val(data.address);
        data = _.extend(data, {
          lat: lat,
          lng: lng,
          current_location: true
        });
        Groupon.Utils.trackEvent('location-bar-geolocation-success', {
          lat: lat,
          lng: lng
        });
        Location.setGeolocationData('geoLocationGranted', true);
        return _this.searchWithAutocomplete(data);
      };
    })(this);
    geoLocationError = (function(_this) {
      return function(err) {
        _this._cleanGeolocationTraces();
        Groupon.Utils.trackEvent('location-bar-geolocation-error', err);
        _this.locationBar.displayAvailabilityError('current-location');
        _this.unfreezeElements();
        return _this.lockSubmit(false);
      };
    })(this);
    return Groupon.Utils.detectCurrentLocation(geolocationSuccess, geoLocationError);
  };

  SearchBarView.prototype.searchWithGmaps = function(options) {
    var address, current_location, geocoderError, geocoderSuccess, lat, lng;
    if (options == null) {
      options = {};
    }
    address = options.address, current_location = options.current_location, lat = options.lat, lng = options.lng, geocoderSuccess = options.geocoderSuccess, geocoderError = options.geocoderError;
    options = {
      address: address,
      location: {
        lat: lat,
        lng: lng
      },
      current_location: current_location,
      country: this.country,
      geocoderSuccess: geocoderSuccess,
      geocoderError: geocoderError
    };
    if (!(geocoderSuccess || geocoderError)) {
      options = _.extend({}, options, {
        geocoderSuccess: this.geocoderSuccess,
        geocoderError: this.geocoderError
      });
    }
    if (!this.geocoder) {
      this.geocoder = new Geocoder();
    }
    return this.geocoder.geocode(options);
  };

  SearchBarView.prototype.searchWithAutocomplete = function(data) {
    var address, query;
    address = data.address, query = data.query;
    Groupon.Utils.trackEvent('location-bar-autocomplete-successful-match', {
      query: query,
      address: address
    });
    if (this.country === 'US') {
      data = breakDownAddress(data);
    }
    data = _.extend({}, data, {
      geocoderSuccess: this.geocoderSuccess,
      geocoderError: this.geocoderError
    });
    return new Geocoder().fetchClosestDivision(data);
  };

  SearchBarView.prototype.geocoderSuccess = function(arg) {
    var address, currentLocationData, current_location, data, locationData, query, trackyEventName;
    address = arg.address, query = arg.query, locationData = arg.locationData, current_location = arg.current_location;
    Location.setELLCookie(locationData.lat + ',' + locationData.lng);
    if (query == null) {
      query = keyword;
    }
    if (locationData.fullAddress != null) {
      address = locationData.fullAddress;
    }
    trackyEventName = 'location-bar-geocode-search-success';
    if (current_location) {
      address = translations.search.nearme;
      trackyEventName = 'location-bar-geolocation-search-success';
    }
    locationData.address = locationData.friendlyName = address;
    Location.setSearchLocCookie(locationData);
    Groupon.Utils.trackEvent(trackyEventName, {
      address: address,
      locationData: locationData,
      query: query
    });
    if ((data = locationData || getLocationForSearch())) {
      data = _.omit(data, ['fullAddress', 'friendlyName', 'types']);
      currentLocationData = _.pick(data, 'lat', 'lng', 'closestDivision', 'division', 'address');
      currentLocationData = _.extend(currentLocationData, {
        timeStamp: new Date().getTime()
      });
      data = _.extend(data, {
        query: query,
        hasLocCookie: true
      });
      storeGeolocationData(current_location, currentLocationData);
      return this.redirectTo(data);
    }
  };

  SearchBarView.prototype.geocoderError = function(arg) {
    var address, data, status;
    address = arg.address, status = arg.status, data = arg.data;
    this.unfreezeElements();
    this.lockSubmit(false);
    if (status === 'ABORT') {
      return;
    }
    if (status === 'BAD_LOCATION') {
      this.locationError.displayBadLocationError(address);
    } else if (status === 'UNAVAILABLE') {
      this.locationError.displayAvailabilityError(address);
    }
    return Groupon.Utils.trackEvent('location-bar-geocode-search-error', {
      address: address,
      data: data
    });
  };

  SearchBarView.prototype.redirectTo = function(data) {
    var address, closestDivision, division, hasLocCookie, newUrl, query, searchEvent;
    closestDivision = data.closestDivision, division = data.division, hasLocCookie = data.hasLocCookie;
    if (!((closestDivision != null) || (division != null))) {
      this.lockSubmit(false);
      return;
    }
    if (closestDivision && !division) {
      division = closestDivision;
    }
    setSiteCookies({
      division: division
    });
    address = data.address, query = data.query;
    searchEvent = query ? hasLocCookie ? 'deal-search-with-loc-cookie' : 'deal-search-with-no-loc-cookie' : 'location-search';
    Groupon.Utils.trackEvent(searchEvent, {
      address: address,
      query: query
    });
    newUrl = getLocationOverrideUrl(data) || getSearchOverrideUrl(division, data, false) || getSearchUrl(division, _.omit(data, 'closestDivision'));
    Groupon.setWindowLocation(newUrl);
  };

  return SearchBarView;

})();

//# sourceMappingURL=data:application/json;base64,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
